const IsNullOrUndefined = (variable) => variable === null || variable === undefined;

export default IsNullOrUndefined;
